import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

/**
 * Legacy `/login` route. Sign-in now happens from CTAs on the landing
 * page (they call kc.login() directly). Visiting /login is just a
 * no-op pass-through: signed-in users continue to the dashboard,
 * signed-out users land on the marketing home.
 */
export default function Login() {
  const { authenticated, ready } = useAuth();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  return <Navigate to={authenticated ? '/dashboard' : '/'} replace />;
}
